export default {
  form: {
    preparation_time: {
      label: 'Angiv egen tid (minutter):',
      placeholder: 'Angiv minutter',
    },
  },
  buttons: {
    custom: 'Brugerdefineret',
  },
  feedback: {
    preparation_time_required: 'Tilberedningstiden skal være over 0 minutter',
    min_preparation_time: 'Mindst {{minutes}} minutters tilberedningstid ved ekstern levering',
    max_preparation_time: 'Højst {{minutes}} minutters tilberedningstid',
  },
};
